export default "__VITE_ASSET__C5Zkr5d8__"